module.exports = __webpack_public_path__ + "static/img/finance-model-empty.750425a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/finance-model-empty.png
// module id = l63m
// module chunks = 1